/**
 * @file
 * Time-based utilities. Use with caution.
 */

/**
 * Returns a promise that resolves after the specified duration.
 *
 * @param ms
 *   The number of milliseconds after which this promise should resolve.
 */
export function wait(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

/**
 * Create a promise whose resolution or rejection can be triggered from somewhere else.
 *
 * See https://stackoverflow.com/a/69027809/836995
 */
export function deferred<T>(): {
  resolve: (value: PromiseLike<T> | T) => void;
  reject: (reason?: any) => void;
  promise: Promise<T>;
} {
  let resolve!: (value: T | PromiseLike<T>) => void;
  let reject!: (reason?: any) => void;
  const promise = new Promise<T>((_resolve, _reject) => {
    resolve = _resolve;
    reject = _reject;
  });

  return {
    resolve,
    reject,
    promise,
  };
}
